export const CURRENCY_DEFINITIONS = [
  {
    code: 'AED',
    label: 'United Arab Emirates Dirham',
    symbol: 'د.إ',
    emoji: '🇦🇪',
    countries: ['AE'] as const,
    locales: ['ar-AE'] as const,
  },
  {
    code: 'AUD',
    label: 'Australian Dollar',
    symbol: 'A$',
    emoji: '🇦🇺',
    countries: ['AU'] as const,
    locales: ['en-AU'] as const,
  },
  {
    code: 'AZN',
    label: 'Azerbaijani Manat',
    symbol: '₼',
    emoji: '🇦🇿',
    countries: ['AZ'] as const,
    locales: ['az-AZ'] as const,
  },
  {
    code: 'BDT',
    label: 'Bangladeshi Taka',
    symbol: '৳',
    emoji: '🇧🇩',
    countries: ['BD'] as const,
    locales: ['bn-BD'] as const,
  },
  {
    code: 'USD',
    label: 'US Dollar',
    symbol: '$',
    emoji: '🇺🇸',
    countries: ['US', 'PR', 'VI'] as const,
    locales: ['en-US'] as const,
  },
  {
    code: 'CAD',
    label: 'Canadian Dollar',
    symbol: 'CA$',
    emoji: '🇨🇦',
    countries: ['CA'] as const,
    locales: ['en-CA', 'fr-CA'] as const,
  },
  {
    code: 'CHF',
    label: 'Swiss Franc',
    symbol: 'CHF',
    emoji: '🇨🇭',
    countries: ['CH'] as const,
    locales: ['de-CH', 'fr-CH', 'it-CH'] as const,
  },
  {
    code: 'CNY',
    label: 'Chinese Yuan',
    symbol: '¥',
    emoji: '🇨🇳',
    countries: ['CN'] as const,
    locales: ['zh-CN'] as const,
  },
  {
    code: 'CZK',
    label: 'Czech Koruna',
    symbol: 'Kč',
    emoji: '🇨🇿',
    countries: ['CZ'] as const,
    locales: ['cs-CZ'] as const,
  },
  {
    code: 'DKK',
    label: 'Danish Krone',
    symbol: 'kr',
    emoji: '🇩🇰',
    countries: ['DK'] as const,
    locales: ['da-DK'] as const,
  },
  {
    code: 'DZD',
    label: 'Algerian Dinar',
    symbol: 'د.ج',
    emoji: '🇩🇿',
    countries: ['DZ'] as const,
    locales: ['ar-DZ'] as const,
  },
  {
    code: 'EGP',
    label: 'Egyptian Pound',
    symbol: 'E£',
    emoji: '🇪🇬',
    countries: ['EG'] as const,
    locales: ['ar-EG'] as const,
  },
  {
    code: 'EUR',
    label: 'Euro',
    symbol: '€',
    emoji: '🇪🇺',
    countries: ['DE', 'FR', 'ES', 'IT', 'NL', 'BE', 'PT', 'IE', 'GR', 'AT', 'FI', 'SK', 'SI', 'EE', 'LV', 'LT', 'LU', 'MT', 'CY'] as const,
    locales: ['de-DE', 'fr-FR', 'es-ES', 'it-IT', 'pt-PT', 'fi-FI', 'et-EE', 'lv-LV', 'lt-LT'] as const,
  },
  {
    code: 'GBP',
    label: 'British Pound',
    symbol: '£',
    emoji: '🇬🇧',
    countries: ['GB'] as const,
    locales: ['en-GB'] as const,
  },
  {
    code: 'GEL',
    label: 'Georgian Lari',
    symbol: '₾',
    emoji: '🇬🇪',
    countries: ['GE'] as const,
    locales: ['ka-GE'] as const,
  },
  {
    code: 'HKD',
    label: 'Hong Kong Dollar',
    symbol: 'HK$',
    emoji: '🇭🇰',
    countries: ['HK'] as const,
    locales: ['zh-HK', 'en-HK'] as const,
  },
  {
    code: 'HUF',
    label: 'Hungarian Forint',
    symbol: 'Ft',
    emoji: '��',
    countries: ['HU'] as const,
    locales: ['hu-HU'] as const,
  },
  {
    code: 'IDR',
    label: 'Indonesian Rupiah',
    symbol: 'Rp',
    emoji: '🇮🇩',
    countries: ['ID'] as const,
    locales: ['id-ID'] as const,
  },
  {
    code: 'ILS',
    label: 'Israeli New Shekel',
    symbol: '₪',
    emoji: '🇮🇱',
    countries: ['IL'] as const,
    locales: ['he-IL'] as const,
  },
  {
    code: 'INR',
    label: 'Indian Rupee',
    symbol: '₹',
    emoji: '🇮🇳',
    countries: ['IN'] as const,
    locales: ['hi-IN', 'en-IN'] as const,
  },
  {
    code: 'JPY',
    label: 'Japanese Yen',
    symbol: '¥',
    emoji: '🇯🇵',
    countries: ['JP'] as const,
    locales: ['ja-JP'] as const,
  },
  {
    code: 'KRW',
    label: 'South Korean Won',
    symbol: '₩',
    emoji: '🇰🇷',
    countries: ['KR'] as const,
    locales: ['ko-KR'] as const,
  },
  {
    code: 'KZT',
    label: 'Kazakhstani Tenge',
    symbol: '₸',
    emoji: '🇰�',
    countries: ['KZ'] as const,
    locales: ['kk-KZ'] as const,
  },
  {
    code: 'LBP',
    label: 'Lebanese Pound',
    symbol: 'ل.ل',
    emoji: '🇱🇧',
    countries: ['LB'] as const,
    locales: ['ar-LB'] as const,
  },
  {
    code: 'MDL',
    label: 'Moldovan Leu',
    symbol: 'L',
    emoji: '🇲🇩',
    countries: ['MD'] as const,
    locales: ['ro-MD'] as const,
  },
  {
    code: 'MXN',
    label: 'Mexican Peso',
    symbol: 'MX$',
    emoji: '��',
    countries: ['MX'] as const,
    locales: ['es-MX'] as const,
  },
  {
    code: 'MYR',
    label: 'Malaysian Ringgit',
    symbol: 'RM',
    emoji: '🇲🇾',
    countries: ['MY'] as const,
    locales: ['ms-MY'] as const,
  },
  {
    code: 'NOK',
    label: 'Norwegian Krone',
    symbol: 'kr',
    emoji: '🇳🇴',
    countries: ['NO'] as const,
    locales: ['nb-NO'] as const,
  },
  {
    code: 'NZD',
    label: 'New Zealand Dollar',
    symbol: 'NZ$',
    emoji: '��',
    countries: ['NZ'] as const,
    locales: ['en-NZ'] as const,
  },
  {
    code: 'PLN',
    label: 'Polish Złoty',
    symbol: 'zł',
    emoji: '🇵🇱',
    countries: ['PL'] as const,
    locales: ['pl-PL'] as const,
  },
  {
    code: 'RON',
    label: 'Romanian Leu',
    symbol: 'lei',
    emoji: '��',
    countries: ['RO'] as const,
    locales: ['ro-RO'] as const,
  },
  {
    code: 'RSD',
    label: 'Serbian Dinar',
    symbol: 'дин.',
    emoji: '🇷🇸',
    countries: ['RS'] as const,
    locales: ['sr-RS'] as const,
  },
  {
    code: 'SAR',
    label: 'Saudi Riyal',
    symbol: '﷼',
    emoji: '🇸🇦',
    countries: ['SA'] as const,
    locales: ['ar-SA'] as const,
  },
  {
    code: 'SEK',
    label: 'Swedish Krona',
    symbol: 'kr',
    emoji: '🇸🇪',
    countries: ['SE'] as const,
    locales: ['sv-SE'] as const,
  },
  {
    code: 'SGD',
    label: 'Singapore Dollar',
    symbol: 'S$',
    emoji: '🇸🇬',
    countries: ['SG'] as const,
    locales: ['en-SG', 'ms-SG', 'zh-SG', 'ta-SG'] as const,
  },
  {
    code: 'THB',
    label: 'Thai Baht',
    symbol: '฿',
    emoji: '🇹🇭',
    countries: ['TH'] as const,
    locales: ['th-TH'] as const,
  },
  {
    code: 'TND',
    label: 'Tunisian Dinar',
    symbol: 'د.ت',
    emoji: '🇹🇳',
    countries: ['TN'] as const,
    locales: ['ar-TN'] as const,
  },
  {
    code: 'TRY',
    label: 'Turkish Lira',
    symbol: '₺',
    emoji: '🇹🇷',
    countries: ['TR'] as const,
    locales: ['tr-TR'] as const,
  },
  {
    code: 'UAH',
    label: 'Ukrainian Hryvnia',
    symbol: '₴',
    emoji: '🇺🇦',
    countries: ['UA'] as const,
    locales: ['uk-UA'] as const,
  },
  {
    code: 'VND',
    label: 'Vietnamese Đồng',
    symbol: '₫',
    emoji: '🇻🇳',
    countries: ['VN'] as const,
    locales: ['vi-VN'] as const,
  },
  {
    code: 'ZAR',
    label: 'South African Rand',
    symbol: 'R',
    emoji: '🇿🇦',
    countries: ['ZA'] as const,
    locales: ['en-ZA', 'af-ZA'] as const,
  },
] as const;

export type CurrencyDefinitionEntry = (typeof CURRENCY_DEFINITIONS)[number];
export type CurrencyDefinition = CurrencyDefinitionEntry;
export type CurrencyCode = CurrencyDefinitionEntry['code'];

const buildDefinitionLookup = () => {
  const lookup = {} as Record<CurrencyCode, CurrencyDefinitionEntry>;
  for (const definition of CURRENCY_DEFINITIONS) {
    lookup[definition.code] = definition;
  }
  return Object.freeze(lookup);
};

const DEFINITION_LOOKUP = buildDefinitionLookup();

export const DEFAULT_CURRENCY_CODE: CurrencyCode = 'USD';

export const currencyDefinitionByCode = DEFINITION_LOOKUP as Readonly<Record<CurrencyCode, CurrencyDefinitionEntry>>;

export const isCurrencyCode = (code: string): code is CurrencyCode =>
  Object.prototype.hasOwnProperty.call(DEFINITION_LOOKUP, code);

export const getCurrencyDefinition = (code: string): CurrencyDefinitionEntry | undefined =>
  isCurrencyCode(code) ? DEFINITION_LOOKUP[code] : undefined;
